/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiGetSceneshotResponseFromJSON(json) {
    return StreemApiGetSceneshotResponseFromJSONTyped(json, false);
}
export function StreemApiGetSceneshotResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sceneshotArtifact': !exists(json, 'sceneshot_artifact') ? undefined : StreemApiArtifactFromJSON(json['sceneshot_artifact']),
    };
}
export function StreemApiGetSceneshotResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sceneshot_artifact': StreemApiArtifactToJSON(value.sceneshotArtifact),
    };
}
//# sourceMappingURL=StreemApiGetSceneshotResponse.js.map